import { mergeClasses, __styles } from '@griffel/react';
const useStyles = /*#__PURE__*/__styles({
  root: {
    a9b677: "fjw5fx7",
    Bqenvij: "fd461yt",
    Bcdw1i0: "fd7fpy0"
  },
  rootChecked: {
    Bcdw1i0: "f1022m68"
  }
}, {
  d: [".fjw5fx7{width:16px;}", ".fd461yt{height:16px;}", ".fd7fpy0{visibility:hidden;}", ".f1022m68{visibility:visible;}"]
});
/**
 * Applies styles to a checkmark slot for selectable menu items
 *
 * @param state - should contain a `checkmark` slot
 */
export const useCheckmarkStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  if (state.checkmark) {
    state.checkmark.className = mergeClasses(styles.root, state.checked && styles.rootChecked, state.checkmark.className);
  }
};
//# sourceMappingURL=useCheckmarkStyles.styles.js.map